module.exports = __webpack_public_path__ + "static/media/duplicate.a2e1839a.svg";